import React from 'react';
import {observer} from 'mobx-react';
import styles from "./dynamic-popup.module.scss";
import classNames from "classnames";
import {Popup} from "../misc/dialog/popup";
import {COLORS} from "../../consts";
import {useDynamicPopup} from "../../../infrastructure/hooks/useDynamicPopup";

export const DynamicPopup = observer(({controller, sportTypeId}) => {
  const {state, device} = controller;
  const {appState} = state;
  const {isSmallView} = device;
  const {dynamicPopupModel, locale, popupsDisplayManager} = appState;
  const {userCountryId} = locale;

  const {shouldRenderPopup, validPopupModel, handleClose, handleButtonClick} = useDynamicPopup({
    dynamicPopupModel,
    sportTypeId,
    userCountryId,
    popupsDisplayManager,
    navigationManager: controller.navigationManager
  });

  if (!validPopupModel) {
    return null;
  }

  const {backgroundImage, title, subtitle, buttonText, buttonColor, disclaimer} = validPopupModel;

  const popupProp = {
    className: classNames(styles.popup, {[styles.small_view]: isSmallView}),
    shouldRenderClearButton: true,
    onClose: handleClose,
    clearButtonColor: COLORS.secondaryBackground
  }

  const containerProps = {
    className: classNames(styles.container),
    style: {
      backgroundImage: `url(${backgroundImage})`
    }
  }

  const buttonProps = {
    className: classNames(styles.button),
    style: {
      backgroundColor: buttonColor
    },
    onClick: handleButtonClick
  }

  return (
    shouldRenderPopup ? <Popup {...popupProp}>
      <div {...containerProps}>
        <div className={classNames(styles.title)}>{title}</div>
        <div className={classNames(styles.subtitle)}>{subtitle}</div>
        <div {...buttonProps}>{buttonText}</div>
        <div className={classNames(styles.disclaimer)}>{disclaimer}</div>
      </div>
    </Popup> : null
  )
});
